import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PROJECTS } from "@/content/work";
import { Reveal } from "@/components/motion/Reveal";
import { CTAButton } from "@/components/site/CTAButton";
import { ConceptBadge, SectionIntro } from "@/components/site/Bits";
import { ConceptThumb } from "@/components/work/ConceptThumb";

export const FeaturedWork = () => (
  <section className="section border-t border-white/[0.08]" data-testid="featured-work-section">
    <div className="container-x">
      <div className="flex flex-col gap-8 md:flex-row md:items-end md:justify-between">
        <SectionIntro
          eyebrow="Featured work"
          title={["Concept redesigns for", "local businesses."]}
          copy="Three sample projects for the kinds of businesses we serve. Fictional names, real approach."
          testId="featured-work-heading"
        />
        <Reveal className="shrink-0">
          <CTAButton to="/work" variant="secondary" testId="featured-work-see-all">
            See all work
          </CTAButton>
        </Reveal>
      </div>
      <div className="mt-14 grid gap-6 md:grid-cols-3">
        {PROJECTS.map((p, i) => (
          <Reveal key={p.id} delay={i * 0.1}>
            <Link to={`/work#${p.id}`} className="group block" data-testid={`featured-work-card-${p.id}`}>
              <ConceptThumb project={p} className="transition-[border-color] duration-300 group-hover:border-white/20" />
              <div className="mt-5 flex items-center justify-between">
                <ConceptBadge />
                <ArrowUpRight
                  className="h-5 w-5 text-white/50 transition-[transform,color] duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-white"
                  aria-hidden="true"
                />
              </div>
              <h3 className="mt-4 text-xl font-medium tracking-tight">{p.name}</h3>
              <p className="mt-1 text-sm text-[#A1A1AA]">{p.industry}</p>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
